import type { MetadataVariant } from "#shared/types/cart";
import type { CartItemDto } from "#shared/types/core/ecommerce/cart";
import type { CheckoutSessionStatus } from "#shared/types/core/ecommerce/checkout";
import type { CoreUserSource } from "#shared/types/core/external/session";

export function createSimpleCartItemMapper(
  totStudents: number,
  isInSalePeriod: boolean,
  source?: CoreUserSource,
) {
  return <TVariant extends string>(
    item: CartItemDto,
    variant: MetadataVariant<TVariant> | undefined,
  ): SimpleCartItem => {
    // TODO: Verify that variant subscription plan is correct and matches the cart item

    let price: SimpleCartItem["price"];
    if (variant) {
      const period = isInSalePeriod ? "recurring" : "initial";
      const calculatedPrice = calculatePrices(variant, totStudents, source, period);
      if (calculatedPrice !== "NOT_APPLICABLE") {
        price = calculatedPrice;
      }
    }

    return {
      id: item.uuid,
      isbn: item.productId ?? variant?.isbn,
      amount: item.amount,
      isTrial: false,
      name: variant?.title || variant?.name || item.productName,
      description: isPacketVariant(variant)
        ? [variant?.description, variant?.subtitle].find((it) => !!it)
        : [variant?.subtitle, variant?.description].find((it) => !!it),
      cover: variant?.cover,
      price,
      fixedAmount: variant?.fixedAmount ?? false,
      parentTitle: variant?.parentTitle,
      type: isPacketVariant(variant) || variant?.formats?.includes("nettsted")
        ? "Digitalt læremiddel"
        : "Digitalbok",
    };
  };
}

export function isCheckoutComplete(status: CheckoutSessionStatus | undefined) {
  return !!status && status !== "NEW";
}
